module.exports = __webpack_public_path__ + "img/mrshao.4d473cf6.jpg";